import React, { useRef, useEffect } from 'react';
import Matter from 'matter-js';

export default function Simulator({ parts, commands }) {
  const sceneRef = useRef();

  useEffect(() => {
    const engine = Matter.Engine.create();
    const world  = engine.world;

    const render = Matter.Render.create({
      element: sceneRef.current,
      engine,
      options: { width: 600, height: 300, wireframes: false, background: '#222' }
    });

    // robot body
    const robot = Matter.Bodies.rectangle(100, 250, 40, 40, {
      render: { fillStyle: '#ddd' }
    });
    Matter.World.add(world, robot);

    // ground
    const ground = Matter.Bodies.rectangle(300, 300, 600, 20, { isStatic: true });
    Matter.World.add(world, ground);

    Matter.Engine.run(engine);
    Matter.Render.run(render);

    // execute commands in sequence
    let idx = 0;
    const runNext = () => {
      if (idx >= commands.length) return;
      const { fn, arg } = commands[idx++];
      switch (fn) {
        case 'forward':
          Matter.Body.translate(robot, { x: arg, y: 0 });
          break;
        case 'turnLeft':
          Matter.Body.rotate(robot, -arg * Math.PI/180);
          break;
        case 'turnRight':
          Matter.Body.rotate(robot,  arg * Math.PI/180);
          break;
        case 'wait':
          // do nothing
          break;
      }
      setTimeout(runNext, fn==='wait'? arg : 500);
    };
    setTimeout(runNext, 500);

    return () => {
      Matter.Render.stop(render);
      Matter.Engine.clear(engine);
      render.canvas.remove();
      render.textures = {};
    };
  }, [commands]);

  return <div ref={sceneRef} />;
}
